/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateCompanyRequestCompanyFromJSON, CreateCompanyRequestCompanyToJSON } from './CreateCompanyRequestCompany';
export function UpdateCompanyRequestFromJSON(json) {
    return UpdateCompanyRequestFromJSONTyped(json, false);
}
export function UpdateCompanyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        company: !exists(json, 'company') ? undefined : CreateCompanyRequestCompanyFromJSON(json['company'])
    };
}
export function UpdateCompanyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company: CreateCompanyRequestCompanyToJSON(value.company)
    };
}
